let tabLabels = null,
    tabTargets = null;

function init() {
    tabLabels = document.querySelectorAll('.tabs-panel__label');
    tabTargets = document.querySelectorAll('.tabs-panel__target');

    if (tabLabels) {
        tabLabels.forEach((tab) => {

            tab.addEventListener('click', () => {

                resetState();
                activeState(tab);

            });
        });
    }
}

function activeState(tabLabel) {
    let target = tabLabel.dataset.panelId;
    document.querySelector(target).classList.add('active');
    tabLabel.classList.add('active');
}

function resetState() {
    tabLabels.forEach((tabLabel) => {
        tabLabel.classList.contains('active') ? tabLabel.classList.remove('active') : null;
    });

    tabTargets.forEach((targetPanel) => {
        targetPanel.classList.contains('active') ? targetPanel.classList.remove('active') : null;
    });
}

export default {init};



// WEBPACK FOOTER //
// ./src/scripts/tabs-panel.js